import { useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import SignaturePad from "react-signature-canvas";

const TandCModal = ({ handleSubmitSignature, loader, btnLabel }) => {
  const navigate = useNavigate();
  let signPad = useRef({});
  const [isSigned, setIsSigned] = useState(false);
  const financierID = localStorage.getItem("allAboard-financierid") !== "undefined" && JSON.parse(localStorage.getItem("allAboard-financierid"));
  const partnerId = localStorage.getItem("allAboard-partnerid") !== "undefined" && JSON.parse(localStorage.getItem("allAboard-partnerid"));

  const clear = () => {
    signPad.current.clear();
    setIsSigned(false);
  };

  const handleReject = () =>{
    navigate("/dashboard");
  }

  return (
    <>
      <div style={{ border: "1px solid lightgrey", borderRadius: "4px" }}>
        <SignaturePad
          ref={signPad}
          onEnd={() => {
            setIsSigned(true);
          }}
          penColor="green"
          canvasProps={{
            width: 600,
            height: 150,
            className: "sigCanvas",
          }}
        />
      </div>
      <div className="mt-4 pull-left">
        <button
          onClick={clear}
          className="btn mr-2"
          style={{ backgroundColor: "brown", color: "white" }}
        >
          Clear Signature
        </button>
        {
          (Number(financierID) !== 20 || Number(partnerId) !== 409) &&
          <button
            onClick={handleReject}
            className="btn mr-2"
            style={{ backgroundColor: "black", color: "white" }}
          >
            Reject
          </button>
        }
        <button
          onClick={() => handleSubmitSignature(signPad.current.toDataURL())}
          disabled={!isSigned}
          className="btn btn-primary"
        >
          {btnLabel} {loader}
        </button>
      </div>
    </>
  );
};

export default TandCModal;
